import { Resolutions, Timeout } from '../common/const';
import { isWidthResize, setScrollbar } from "../common/utils";

class Search {
    constructor(block) {
        this.block = block;
        this.input = this.block.querySelector(`[data-search-input]`);
        this.inputPlug = document.querySelector(`#search-input-plug`);
        this.resetBtn = this.block.querySelector(`[data-search-reset]`);
        this.submitBtn = this.block.querySelector(`[data-search-submit]`);
        this.closeBtn = this.block.querySelector(`[data-search-close]`);
        this.result = document.querySelector(`[data-search-result]`);
        this.overlay = document.querySelector(`[data-overlay]`);
        this.onInput = this.onInput.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onResetBtnClick = this.onResetBtnClick.bind(this);
        this.onCloseBtnClick = this.onCloseBtnClick.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onWidthResize = () => this.onResize();
    }

    scrollToInput() {
        const inputOffset = 20;
        const inputRect = this.input.getBoundingClientRect();

        if (Resolutions.IS_TAB() && inputRect.top !== inputOffset) {
            this.block.scrollTo({
                top: inputRect.top - inputOffset,
                behavior: "smooth",
            });
        }
    }

    showResult() {
        $(this.result).fadeIn(Timeout.FADE);
        const resultBXBlock = document.querySelector(`.title-search-result`);
        if (resultBXBlock) resultBXBlock.style.display = `block`;

        this.overlay.classList.add(`is-viewed`);
        if (Resolutions.IS_TAB()) document.body.classList.add(`no-scroll`);
        setTimeout(() => {
            this.overlay.classList.add(`animation`);
        }, Timeout.SHORT_TIMEOUT);
    }

    hideResult() {
        $(this.result).fadeOut(Timeout.FADE);
        const resultBXBlock = document.querySelector(`.title-search-result`);
        if (resultBXBlock) resultBXBlock.style.display = `none`;

        // this.overlay.classList.remove(`animation`);
        // setTimeout(() => {
        //     this.overlay.classList.remove(`is-viewed`);
        //     document.body.classList.remove(`no-scroll`);
        // }, Timeout.ANIMATION_TOGGLE);
    }

    onInput(e) {
        const value = e.target.value;
        if (value.length > 0) {
            if (this.resetBtn) this.resetBtn.classList.add(`active`);
            if (this.submitBtn) this.submitBtn.classList.remove(`active`);
            if (this.result) this.showResult();
        } else {
            if (this.resetBtn) this.resetBtn.classList.remove(`active`);
            if (this.submitBtn) this.submitBtn.classList.add(`active`);
            if (this.result) this.hideResult();
        }

        this.scrollToInput();
    }

    onFocus(e) {
        if (this.result && e.target.value.length > 0) this.showResult();
        this.scrollToInput();
    }

    onResetBtnClick(e) {
        if (e.target.classList.contains(`active`)) {
            e.preventDefault();
            this.input.value = ``;
            this.input.dispatchEvent(new Event(`input`));
            e.target.classList.remove(`active`);
        }
    }

    onCloseBtnClick(e) {}

    onOverlayClick(e) {
        this.hideResult();
    }

    onResize() {
        if (this.result) this.result.style = ``;
    }

    // перенос блока результатов поиска из body в header
    headerSearchMutation() {
        const $searchResultBlock = $(`.title-search-result`);

        if (!$searchResultBlock.length) return;
        $(`#search-form`).append($searchResultBlock);
    }

    init() {
        this.headerSearchMutation();

        // ввод значений в инпут и показ результатов
        this.input.addEventListener(`input`, this.onInput);

        // показ результатов на фокус инпута
        this.input.addEventListener(`focus`, this.onFocus);

        // скрытие результатов при потере фокуса
        this.input.addEventListener(`focusout`, e => {
            //  const parent = findAncestorByAttr(e.currentTarget, `data-search-block`);
            //  console.log('parent', parent)
            //  console.log('relatedTarget', e.relatedTarget)
            // if (this.result && !parent.contains(e.relatedTarget)) this.hideResult();
        });

        // клик по кнопке reset
        this.resetBtn && this.resetBtn.addEventListener(`click`, this.onResetBtnClick);
        // клик по закрытию поиска в моб версии
        // this.closeBtn.addEventListener(`click`, this.onCloseBtnClick);
        // клик по оверлею
        this.overlay.addEventListener(`click`, this.onOverlayClick);

        isWidthResize(this.onWidthResize);
    }
}

export const initSearch = () => {
    const blocks = document.querySelectorAll(`[data-search-block]`);
    if (!blocks.length) return;
    blocks.forEach(block => new Search(block).init());
};

window.initSearch = (block) => new Search(block).init();
